// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPlanPrimaryConfigLiteDto
 */
export interface IPlanPrimaryConfigLiteDto {
    /**
     * 
     * @type {number}
     * @memberof IPlanPrimaryConfigLiteDto
     */
    investment_threshold?: number;
    /**
     * 
     * @type {number}
     * @memberof IPlanPrimaryConfigLiteDto
     */
    catch_up_age?: number;
    /**
     * 
     * @type {Set<string>}
     * @memberof IPlanPrimaryConfigLiteDto
     */
    investment_options_type?: Set<IPlanPrimaryConfigLiteDtoInvestmentOptionsTypeEnum>;
    /**
     * 
     * @type {number}
     * @memberof IPlanPrimaryConfigLiteDto
     */
    minimum_investment_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IPlanPrimaryConfigLiteDto
     */
    omnibus_type?: IPlanPrimaryConfigLiteDtoOmnibusTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IPlanPrimaryConfigLiteDto
     */
    is_carded?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum IPlanPrimaryConfigLiteDtoInvestmentOptionsTypeEnum {
    MANAGED = 'MANAGED',
    SELF_DIRECTED = 'SELF_DIRECTED',
    BROKERAGE = 'BROKERAGE'
}
/**
* @export
* @enum {string}
*/
export enum IPlanPrimaryConfigLiteDtoOmnibusTypeEnum {
    HSA = 'HSA',
    NOTIONAL = 'NOTIONAL'
}


/**
 * Check if a given object implements the IPlanPrimaryConfigLiteDto interface.
 */
export function instanceOfIPlanPrimaryConfigLiteDto(value: object): value is IPlanPrimaryConfigLiteDto {
    return true;
}

export function IPlanPrimaryConfigLiteDtoFromJSON(json: any): IPlanPrimaryConfigLiteDto {
    return IPlanPrimaryConfigLiteDtoFromJSONTyped(json, false);
}

export function IPlanPrimaryConfigLiteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlanPrimaryConfigLiteDto {
    if (json == null) {
        return json;
    }
    return {
        
        'investment_threshold': json['investment_threshold'] == null ? undefined : json['investment_threshold'],
        'catch_up_age': json['catch_up_age'] == null ? undefined : json['catch_up_age'],
        'investment_options_type': json['investment_options_type'] == null ? undefined : new Set(json['investment_options_type']),
        'minimum_investment_amount': json['minimum_investment_amount'] == null ? undefined : json['minimum_investment_amount'],
        'omnibus_type': json['omnibus_type'] == null ? undefined : json['omnibus_type'],
        'is_carded': json['is_carded'] == null ? undefined : json['is_carded'],
    };
}

export function IPlanPrimaryConfigLiteDtoToJSON(json: any): IPlanPrimaryConfigLiteDto {
    return IPlanPrimaryConfigLiteDtoToJSONTyped(json, false);
}

export function IPlanPrimaryConfigLiteDtoToJSONTyped(value?: IPlanPrimaryConfigLiteDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'investment_threshold': value['investment_threshold'],
        'catch_up_age': value['catch_up_age'],
        'investment_options_type': value['investment_options_type'] == null ? undefined : Array.from(value['investment_options_type'] as Set<any>),
        'minimum_investment_amount': value['minimum_investment_amount'],
        'omnibus_type': value['omnibus_type'],
        'is_carded': value['is_carded'],
    };
}

